import styled from "@emotion/styled";

export const CheckIssueWrapper = styled.div({
    paddingTop: "8px",
});
